<template>
  <div>
    <b-navbar toggleable="lg" type="dark" variant="info" class="empanel-main-header">
      <span class="ml-2">
        <img src="../assets/Empanel_Logo.png" />
      </span>
      <span class="header-line-headertext ml-3 mr-2"></span>
      <span class="navebar-empanelment-main-text ml-2" 
      :style="[selectedCompanyName.toLowerCase().indexOf('geo') > -1 ? {color:'#fdcb00!important'} : {}]">{{selectedCompanyName}}</span>
      <b-navbar-toggle target="nav-collapse"></b-navbar-toggle>
      <b-collapse id="nav-collapse" is-nav>
        <b-navbar-nav class="ml-auto">
          <b-nav-form>
            <!-- <w-search-bar /> -->
          </b-nav-form>
          <span class="ml-3 mr-2 mt-4">
            <!-- <font-awesome-icon icon="bell" size="2x" style="color:white" /> -->
          </span>
          <span class="navebar-empanelment-sub-text mt-4">Partner Portal - PartnerDashboard</span>
          <span class="navebar-empanelment-sub-text mt-4" @click="goToReminders()"
          style="margin-left: 10px !important;margin-right: -10px !important;cursor:pointer;">
            <img src="../assets/bell.png" style="width: 24px;"/><span v-if="notificationCount && notificationCount>0"
            style="background: red;border-radius: 50px;padding: 3px;font-size: 12px;position: relative;
    top: -14px;right: 10px;">&nbsp;{{notificationCount}}&nbsp;</span>
          </span>
          <span class="header-line-headertext ml-3 mr-2 mt-3"></span>
          <p class="ml-2 mr-2 mt-3">
            <span class="username" :title="userName">{{userName}}</span>
            <br />
            <span class="time-class">{{ new Date() | moment }}</span>
          </p>
          <b-img v-bind="mainProps" rounded="circle" alt="Profile" class="mt-4"></b-img>
          <b-nav-item-dropdown class="mr-1 text-left mt-3" right no-caret>
            <template slot="button-content">
              <span class="ml-1">
                <img src="../assets/down.png" width="9" />
              </span>
            </template>
           <div style="padding:5px;"> <span style="width:120px;display:inline-block;font-weight:bold;">Switch Company:</span>
            <select style="width:150px;display:inline-block;appearance: menulist !important;
            -webkit-appearance: menulist !important;" class="form-control" v-model="currentCompany" 
            @change="switchCompany()">
              <option v-for="i in companyList" :key="i"
              :value="i.companyCode">{{i.company}}</option>
            </select>
           </div>
            <b-dropdown-item @click="changePassword($event)">Change Password</b-dropdown-item>
            <b-dropdown-item @click="signOut($event)">Sign Out</b-dropdown-item>
          </b-nav-item-dropdown>
        </b-navbar-nav>
      </b-collapse>
    </b-navbar>
    <!--b-navbar class="empanel-sub-header"-->
      <!-- <marquee class="marquee" v-show="alertPresent">
        <p class="scrolling-text mt-3">
          <span
            class="scroll-message"
            v-for="scrollMessage in scrollMessages"
            :key="scrollMessage.messageId"
          >{{scrollMessage.message}}</span>
        </p>
      </marquee>
      <b-alert
        v-show="alertPresent"
        show
        class="alert-scroll-message"
        dismissible
        @dismissed="closeAlert()"
      ></b-alert>-->
      <!-- <span class="mt-1 home-icon">
        <i class="material-icons cursor-pointer" @click="goToBuyerDashBoad()">home</i>
      </span>
      <span>
        <img src="../assets/Back_Arrow.svg" width="15" />
      </span>
      <b-breadcrumb :items="breadcrumbItems" class="breadcrumb" v-if="showBreadcrumb" />-->
    <!--/b-navbar-->
    <!-- <b-card class="card-alert">
      <div class="row card-row">
        <div class="col-sm-11 text-left">
          <span
            class="scroll-message"
            v-if="!readMore"
          >{{scrollMessages[messageIndex].message.slice(0, 200)}}&nbsp;</span>
          <a
            class
            v-if="!readMore && scrollMessages[messageIndex].message.slice(0, 200).length < scrollMessages[messageIndex].message.length"
            @click="readMore=true"
            href="#"
          >read more</a>
          <span
            class="scroll-message"
            v-if="readMore"
          >{{scrollMessages[messageIndex].message}}&nbsp;</span>
          <a class v-if="readMore" @click="readMore=false" href="#">read less</a>
        </div>
        <div class="col-sm-1 text-right">
          <eva-icon name="chevron-left" @click="previousMessage()"></eva-icon>&nbsp;
          <eva-icon name="chevron-right" @click="nextMessage()"></eva-icon>
        </div>
      </div>
    </b-card> -->
  </div>
</template>
<script>
import SearchBar from "../widgets/SearchBar.vue";
import moment from "moment";
const ESCAPE_LOGOUT_HASH = "#logout";
import { DashboardService } from "../services/DashboardService";
import { PartnerService } from "../services/partnerService";
const partnerService = new PartnerService();
const service = new DashboardService();

export default {
  props: ["userName", "protalName"],
  components: {
    "w-search-bar": SearchBar
  },
  data() {
    return {
      selectedCompanyName:"",
      notificationCount: 0,
      companyCode:"",
      categoryCode:"",
      companyList:[],
      currentCompany:"",
      mainProps: {
        blank: true,
        blankColor: "white",
        width: 20,
        height: 20,
        class: "m1"
      },
      breadcrumbItems: [
        { text: "", to: "" },
        { text: "", active: true }
      ],
      showBreadcrumb: false,
      // scrollMessages: [],
      // alertPresent: true,
      // messageIndex: 0,
      // readMore: false
    };
  },
  watch: {
    $route() {
      this.determineBreadcrumb();
    }
  },
  filters: {
    moment: function(date) {
      return moment(date).format("DD MMM YYYY, h:mm a");
    }
  },
  created() {
    this.determineBreadcrumb();
    var self = this
    this.getNotificationDetails()
    service.getPartnerCompanies().then(resp => {
          if (resp.failureMessage == "") {
            this.companyList = resp.response.companyMappingResponseList
            //this.companyCode = resp.response.filter(x=>x.isDefault==true)[0].companyCode
            
     partnerService.getPartnerInfo().then(resp1 => {
       self.categoryCode = resp1.response.currentCategoryCode; 
        self.companyCode = resp1.response.currentCompanyCode; 
        this.$root.isInternational =
              resp1.response.countryDetail.countryCode == 100 ? false : true;
            self.currentCompany = self.companyCode
            self.selectedCompanyName= resp.response.companyMappingResponseList.filter(x=>x.companyCode==self.currentCompany)[0].longDesc            
            self.userName = resp1.response.longDesc
            //sessionStorage.setItem("currentCompanyName", this.selectedCompanyName)
     });
            //window.alert(this.selectedCompanyName+" "+this.companyCode)
          }});
    // this.getScrollMessages();
    
    EventBus.$on('updateNotificationCount',function(){     
    self.getNotificationDetails()
    });
  },
  methods: {
    goToReminders(){ 
      this.loading = true;     
      if(this.$route.name != 'PartnerReminer'){
      this.$router.push('PartnerReminder')
      }
    },
    getNotificationDetails() {
      partnerService
        .getNotificationDetails()
        .then(res => {
          //this.notificationDetailsList = res.response;
          this.loading = false;
          this.notificationCount = res.response.filter(x=>x.notificationStatus=='D').length
          if(this.notificationCount > 0) {
            this.goToReminders()
          }
        })
        .catch(e => {
          this.loading = false;
        });
    },
    // previousMessage() {
    //   this.readMore = false;
    //   if (this.messageIndex != 0) {
    //     this.messageIndex -= 1;
    //   } else {
    //     this.messageIndex = this.scrollMessages.length - 1;
    //   }
    // },
    // nextMessage() {
    //   this.readMore = false;
    //   if (this.messageIndex != this.scrollMessages.length - 1) {
    //     this.messageIndex += 1;
    //   } else {
    //     this.messageIndex = 0;
    //   }
    // },
    switchCompany(){
      var self = this
      this.companyCode = this.currentCompany      
      this.selectedCompanyName= this.companyList.filter(x=>x.companyCode==this.companyCode)[0].longDesc
      
      service.getCompanyNavigation(this.companyCode).then(resp => {
      service
        .getProfileDetails(this.categoryCode, this.companyCode)
        .then(resp => {
          if (resp.response == "User Category Audit Recorded") {
            sessionStorage.setItem("currentCategoryCode", this.currentBusinessCode)
            sessionStorage.setItem("currentCompanyCode", this.companyCode)
            sessionStorage.setItem("currentCompanyName", this.selectedCompanyName)       
            self.$router.go(0)
            //EventBus.$emit('switchCompany', {"companyCode":this.companyCode, "companyName": this.selectedCompanyName})
          }
        });
      });
    },
    closeAlert() {
      this.alertPresent = false;
    },
    changePassword() {
      this.$router.push({
        name: "ChangePasswordPage",
        params: {
          currentDashboard: "partnerDashboard"
        }
      });
      sessionStorage.setItem("currentroute", "partnerdashboard");
    },
    getRouteMap() {
      if (localStorage.getItem("routeMap")) {
        // Code written for page refresh
        let json = JSON.parse(localStorage.getItem("routeMap"));
        json = json.filter(e => e !== "[Unknown]");
        let newMap = new Map(json);
        return newMap;
      } else {
        return new Map();
      }
    },
    // Code used for breadcumbs issue
    censor(censor) {
      var i = 0;
      return function(key, value) {
        if (
          i !== 0 &&
          typeof censor === "object" &&
          typeof value == "object" &&
          censor == value
        )
          return "[Circular]";
        if (i >= 29)
          // seems to be a harded maximum of 30 serialized objects?
          return "[Unknown]";
        ++i; // so we know we aren't using the original object anymore
        return value;
      };
    },
    clearRouteMap() {
      localStorage.removeItem("routeMap");
    },
    signOut() {
      this.$emit("userLogout");
    },
    determineBreadcrumb() {
      let currentRoute = this.$route;
      //if parent is present, it means it is sub-route
      if (
        currentRoute.meta &&
        currentRoute.meta.breadcrumb &&
        currentRoute.meta.breadcrumb.parent
      ) {
        //look for parent route in map
        let parentRouteName = currentRoute.meta.breadcrumb.parent;
        if (this.getRouteMap() && this.getRouteMap().has(parentRouteName)) {
          let label = currentRoute.meta.breadcrumb.label;
          this.showBreadcrumb = true;
          let parentRoute = this.getRouteMap().get(parentRouteName);
          this.breadcrumbItems[0].text = label ? label : parentRoute.name;
          this.breadcrumbItems[0].to = parentRoute.path;
          this.breadcrumbItems[1].text = currentRoute.name;
        }
      } else {
        //no parent route, reset routemap
        this.clearRouteMap();
        //hide breadcrumb
        this.showBreadcrumb = false;
      }
    },
    // getScrollMessages() {
    //   var scrollMessageRequest = {
    //     listMessageTypeId: [],
    //     loginAuditNumber: null
    //   };
    //   scrollMessageRequest.listMessageTypeId.push(3);
    //   scrollMessageRequest.listMessageTypeId.push(4);
    //   scrollMessageRequest.loginAuditNumber = sessionStorage.getItem(
    //     "AuditNumber"
    //   );
    //   service
    //     .getScrollMessages(scrollMessageRequest)
    //     .then(res => {
    //       this.scrollMessages = res.response;
    //     })
    //     .catch(err => {
    //       console.log(err);
    //     });
    // }
  }
};
</script>

<style scoped>
.time-class {
  font-family: "Source Sans Pro", sans-serif;
  font-size: 14px;
  font-weight: 300;
  font-style: normal;
  font-stretch: normal;
  line-height: 1.29;
  letter-spacing: normal;
  text-align: right;
  color: darkturquoise;
}
.home-icon {
  color: #8aa1b5;
}
.empanel-main-header {
  height: 60px;
  background-image: linear-gradient(to bottom, #1d76ae, #055396);
}
.empanel-sub-header {
  z-index: 5;
  height: 30px;
  background-image: linear-gradient(to bottom, #14436a, #14436a);
}
/* .card-alert {
  position: inherit;
  margin: auto !important;
  width: 100%;
  padding: 0 0 0 0;
}
.card-row {
  margin-left: 15%;
  position: inherit;
} */
.header-line-headertext {
  border: solid 0.6px #478dbb;
  width: 0px;
  color: #1d76ae;
  height: 40px;
}
.avatar-img {
  width: 25px;
  height: 25px;
  border-radius: 50% !important;
}
.username {
  font-family: "Source Sans Pro", sans-serif;
  font-size: 16px;
  font-weight: 600;
  font-style: normal;
  font-stretch: normal;
  line-height: 1.25;
  letter-spacing: normal;
  text-align: right;
  color: whitesmoke;
  max-width: 225px;
    overflow: hidden;
    text-overflow: ellipsis;
    display: inline-block;
    white-space: nowrap;
}
.breadcrumb {
  position: relative;
  top: 0px;
  background-color: transparent !important;
  margin-bottom: 3px !important;
  margin-top: 3px !important;
  padding-bottom: 0 !important;
  padding: 0 !important;
}
.breadcrumb a {
  font-family: Roboto !important;
  font-style: normal !important;
  font-weight: bold !important;
  font-size: 14px !important;
  color: white !important;
  opacity: 0.8 !important;
}
.breadcrumb a:hover {
  text-decoration: none;
}
.breadcrumb-item + .breadcrumb-item::before {
  display: inline-block !important;
  padding-right: 0.5rem !important;
  opacity: unset;
  text-decoration: none;
  /* content: url(../assets/Vector.png) !important; */
  /* display: none !important; */
}
.breadcrumb-item.active {
  font-family: Roboto !important;
  font-style: normal !important;
  font-weight: bold !important;
  font-size: 14px !important;
  /* text-transform: uppercase !important; */
  color: #9ba5bc !important;
  opacity: 0.8 !important;
}
.material-icons {
  font-size: 18px !important;
}
.navebar-empanelment-main-text {
  font-family: "Source Sans Pro", sans-serif;
  float: left !important;
  color: whitesmoke !important;
  font-weight: bold !important;
  font-size: 18px !important;
}
.navebar-empanelment-sub-text {
  margin-left: auto !important;
  font-family: "Source Sans Pro", sans-serif;
  float: right !important;
  color: whitesmoke !important;
  font-weight: bold !important;
  font-size: 18px !important;
}
/* .scroll-message {
  color: black;
  font-family: "Source Sans Pro", sans-serif;
  font-size: 15px !important;
  font-weight: 200px;
  padding: 0 0 0 0;
} */
</style>
